// src/quiz/gre-mock4/index.js
// GRE Mock 4 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 4" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock4 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 4",
    title: "GRE Verbal Reasoning — Mock 4",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 4",
    title: "GRE Quantitative Reasoning — Mock 4",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 4",
    title: "GRE Analytical — Mock 4",
    prompt:
      "\"The surest way to judge the character of a society is to examine how it treats those who have no power to reward it.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the statement and explain your reasoning for the position you take. In developing and supporting your position, you should consider ways in which the statement might or might not hold true and explain how these considerations shape your position.",
    topicKeywords: [
      "societ", "character", "judg", "treat", "power", "vulnerab",
      "reward", "justice", "moral", "protect", "rights", "weak",
    ],
  },
};
